import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import type { FaqItem } from "@/types/home";

/** Reusable, accessible FAQ accordion for detail pages. */
export function FaqAccordion({ faqs }: { faqs: FaqItem[] }) {
  return (
    <Accordion
      type="single"
      collapsible
      defaultValue="faq-0"
      className="mx-auto w-full max-w-3xl"
      data-testid="faq-accordion"
    >
      {faqs.map((item, i) => (
        <AccordionItem key={i} value={`faq-${i}`} className="border-b border-border">
          <AccordionTrigger className="py-5 text-left font-heading text-base font-semibold text-foreground hover:no-underline data-[state=open]:text-primary">
            {item.question}
          </AccordionTrigger>
          <AccordionContent className="pb-5 text-[15px] leading-relaxed text-muted-foreground">
            {item.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
